import * as React from "react";
import ReadMoreReact from "read-more-react";
import { Link } from "react-router-dom";
import { Row, Col, NavLink, UncontrolledCollapse } from "reactstrap";
import Footer from "../Layout/Footer";

import Milestone from "../Layout/common/Milestone";
import PhasesChart from "../Layout/common/PhasesChart";

import "./ProjectDetails.scss";

// TODO: Clean up, seperate props and state, use proper data structures
export interface ProjectDetailsState {
  id: any;
  src: string;
  projectTitle: string;
  aboutUs: string;
  aboutProject: string;
  legalContact: string;
  permits: number;
  current: number;
  extaParts: number;
  salary: number;
  phase: number;
  backers: number;
  needed: number;
  width: number;
  height: number;
  heightAbout: number;
  heightMilestones: number;
  href: string;
  externalAuditors: string;
  phases: any;
}

class ProjectDetails extends React.Component<ProjectDetailsState> {
  state = {
    id: "",
    src: "assets/images/Green_turtle_swimming_over_coral_reefs_in_Kona.jpg",
    projectTitle:
      "One Earth - One Ocean e.V. - Collect and recycle marine plastic waste",
    aboutProject:
      "The urgency to solve the problem of marine litter should now be clear to everyone. One Earth - One Ocean e.V.'s goal is to clean up water bodies worldwide of plastic waste, oil and chemicals.The multi-stage concept of 'Maritime litter cleanup' envisages collecting plastic garbage with special garbage collection vessels designed by us and then recycling it or converting it into oil.In addition, our association is engaged in national and international oil cleaning, research into microplastic as well as educational work and documentation on marine littering.",
    aboutUs:
      "In 2013, One Earth - One Ocean e.V. was awarded the prestigious GreenTec Award 2013, Europe's largest environmental and business award, for its concept of 'marine litter cleanup'. In 2016, it was nominated for the Federal Ecodesign Award, the highest honor for ecological design in Germany. Finally, in 2018, the club was nominated for the Ocean Tribute Award by Prince Albert II of Monaco, who honors the most innovative and sustainable marine conservation ideas. ",
    legalContact: "Derik Brandwerder",
    permits: 5000,
    extaParts: 50000,
    salary: 50000,
    phase: 3,
    backers: 5,
    needed: 10.4,
    height: 0,
    heightAbout: 0,
    current: 2,
    heightMilestones: 0,
    href: "https://material.io",
    externalAuditors: "James Korbey (KAMG)",
    phases: [
      { phase: "1", needed: 25000 },
      { phase: "2", needed: 6000 },
      { phase: "3", needed: 30000 }
    ]
  };

  componentWillMount() {
    //Action get Project details by id
  }

  render() {
    const {
      projectTitle,
      src,
      aboutProject,
      aboutUs,
      legalContact,
      permits,
      extaParts,
      salary,
      phase,
      backers,
      needed,
      height,
      heightAbout,
      href,
      heightMilestones,
      externalAuditors,
      current,
      phases
    } = this.state;
    const divStyle = { backgroundImage: "url(" + src + ")" };

    return (
      <div>
        <div className="section__header-img" style={divStyle} />
        <div className="section section--content">
          <h1 className="section__title">{projectTitle}</h1>

          <Row>
            <Col md={6} lg={4}>
              <div className="collapse-block" id="collapse-block">
                <div className="collapse-block__title" id="toggler_aboutus">
                  <img
                    className="collapse-block__icon"
                    src="assets/images/icons/plus.svg"
                    alt="open"
                  />
                  About us
                </div>
                <UncontrolledCollapse
                  className="collapse-block__content"
                  toggler="#toggler_aboutus"
                >
                  <ReadMoreReact
                    text={aboutUs}
                    min={0}
                    ideal={1000}
                    max={1000}
                  />
                </UncontrolledCollapse>
              </div>
            </Col>
            <Col md={6} lg={4}>
              <div className="collapse-block" id="collapse-block">
                <div className="collapse-block__title" id="toggler_project">
                  <img
                    className="collapse-block__icon"
                    src="assets/images/icons/plus.svg"
                    alt="open"
                  />
                  About The Project
                </div>
                <UncontrolledCollapse toggler="#toggler_project">
                  <ReadMoreReact
                    text={aboutProject}
                    min={0}
                    ideal={1000}
                    max={1000}
                  />
                </UncontrolledCollapse>
              </div>
            </Col>
            <Col lg={4}>
              <div className="collapse-block" id="collapse-block">
                <div className="collapse-block__title" id="toggler_milestones">
                  <img
                    className="collapse-block__icon"
                    src="assets/images/icons/plus.svg"
                    alt="open"
                  />
                  Milestones
                </div>
                <UncontrolledCollapse toggler="#toggler_milestones">
                  <Milestone
                    text="GET PERMITS"
                    price={permits}
                    divided="4 ETH"
                  />
                  <Milestone
                    text="Build Extra Parts"
                    price={extaParts}
                    divided="4 ETH"
                  />
                  <Milestone
                    text="Teacher 1 Year"
                    price={salary}
                    divided="4 ETH"
                  />
                  <NavLink className="read-milestone" href="#">
                    Read Milestone Details
                  </NavLink>

                  <Row>
                    <Col sm={{ size: 5, offset: 1 }}>
                      <div className="legal-contact">
                        <p>Legal Contact</p>
                        <span>{legalContact}</span>
                      </div>
                    </Col>
                    <Col sm={{ size: 5, offset: 1 }}>
                      <div className="legal-contact external">
                        <p>External Auditors</p>
                        <span>{externalAuditors}</span>
                      </div>
                    </Col>
                  </Row>
                </UncontrolledCollapse>
              </div>
            </Col>
          </Row>
          <PhasesChart
            detailsPage={true}
            current={current}
            phases={phase}
            backers={backers}
            phasesArr={phases}
            needed={needed}
            width={1000}
            height={300}
          />
        </div>

        <div className="bottomcover">
          <Link className="go-back" to="/">
            <img
              className="chevron-left"
              src="assets/images/icons/back.svg"
              alt="open"
            />
          </Link>

          <Link className="help-fund text-white" to="/">
            HELP FUND THE PROJECT
          </Link>
          <Footer />
        </div>
      </div>
    );
  }
}

export default ProjectDetails;
